<template>
    <div>
        <v-row>
            <v-col cols="2">
                <div>
                  <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-select
                          :items="companies"
                          v-model="filters.company"
                          label="Firma"
                          item-value="id"
                          solo
                          v-bind="attrs"
                          v-on="on"
                          class="wastemaster-input-elevation"
                      >
                        <template v-slot:selection="data">
                          {{ data.item.name }}
                        </template>
                        <template v-slot:item="data">
                          {{ data.item.name }}
                        </template>
                      </v-select>
                    </template>
                  </v-menu>
                </div>
                <v-btn @click="get();" color="primary" block>Filtruj</v-btn>
            </v-col>
            <v-col cols="10">
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        class="elevation-1 row-pointer"
                        :items-per-page="300"
                        :footer-props="{
                          'items-per-page-options': [300, 50]
                        }"
                        @click:row="(priceList) => $router.push({name: 'price-list-details', params: { id: priceList.id }}).catch(()=>{})"
                >
                    <template v-slot:item.type="{ item }">
                        {{ item.type.name }}
                    </template>
                    <template v-slot:item.company="{ item }">
                        {{ item.company.name }}
                    </template>
                    <template v-slot:item.prices="{ item }">
                      <div class="flex-row d-flex gap-4">
                        <div
                            v-for="price in item.prices"
                            :key="price.dateFrom"
                            class="mb-2"
                        >
                          <strong>{{ tabLabel(price) }}</strong>
                          <div
                              v-for="dayPrice in price.dayPrices"
                              :key="dayPrice.dayFrom"
                          >
                            <div>
                              {{ dayPrice.dayFrom }}
                              {{
                                dayPrice.to
                                    ? ' - ' + dayPrice.dayTo + ' dni'
                                    : ' dni i więcej'
                              }}
                              <strong> {{ dayPrice.price }} zł</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                  <template v-slot:item.addtional="{ item }">
                    <div>
                      <strong>Zniżka: </strong> {{ item.discount ? item.discount : '0' }}%
                    </div>
                    <div>
                      <strong>Ubezpiecznie (za dzień): </strong>
                      {{ item.insurance !== null ? item.insurance : '-' }} zł
                    </div>
                    <div>
                      <strong>Kaucja bez ubezpieczenia: </strong>
                      {{ item.deposit !== null ? item.deposit : '-' }} zł
                    </div>
                    <div>
                      <strong>Kaucja z ubiezpieczeniem: </strong>
                      {{ item.depositWithInsurance !== null ? item.depositWithInsurance : '-' }} zł
                    </div>
                    <div>
                      <strong>Wkład własny bez ubezpieczenia: </strong>
                      {{ item.ownContribution !== null ? item.ownContribution : '-' }} zł
                    </div>
                    <div>
                      <strong>Wkład własny z ubezpieczeniem: </strong>
                      {{ item.ownContributionWithInsurance !== null ? item.ownContributionWithInsurance : '-' }} zł
                    </div>
                  </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import {getDatatableParams, setDatatableOptions, setDatatableFilters} from '@/utils/helpers';
    import {getStatusText, WholesaleInquiryStatus} from '@/enums/WholesaleInquiryStatus';
    import {getCategoryText} from '@/enums/WholesaleInquiryCategory';
    import moment from 'moment';
    import permissions from '@/mixins/permissions';

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          DataTable,
        },
        data () {
            return {
                statuses: WholesaleInquiryStatus,
                modal: false,
                companies: [],
                filters: {
                    status: null,
                },
                total: 0,
                items: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'Typ', value: 'type', sortable: false },
                    { text: 'Firma', value: 'company', sortable: false },
                    { text: 'Ceny', value: 'prices', sortable: false },
                    { text: 'Dodatkowe ceny', value: 'addtional', sortable: false },
                ],
                reactOnFilterChange: true,
                stats: [],
            }
        },
        watch: {
            options: {
                handler () {
                    this.get();
                },
                deep: true,
            },
            filters: {
                handler() {
                    if (!this.reactOnFilterChange) {
                        return;
                    }

                    setDatatableFilters.call(this);
                },
                deep: true
            },

        },
        methods: {
          async getCompanies() {
            this.loading = true;

            const response = await api.get('/api/price-list/company?rental=true', {});
            this.loading = false;

            this.companies = [{id: 0, name: "Wybierz firmę"}].concat(response.data.items)
          },
          getCategoryText,
          tabLabel(price) {
            if (price.from && price.to) {
              const from = moment(price.from).format('DD-MM')
              const to = moment(price.to).format('DD-MM')
              if (from === '01-01' && to === '31-12') {
                return 'cały rok'
              }
              return `${this.formatDate(price.from)} - ${this.formatDate(price.to)}`
            }
          },
            async get() {
                this.loading = true;

                const { page, itemsPerPage } = this.options;

                if (this.filters.dateFrom) {
                    const dateFromString = String(this.filters.dateFrom).substr(0, 10);
                    this.reactOnFilterChange = false;

                    if (!moment(dateFromString).isValid()) {
                      this.filters.dateFrom = this.getDateFrom();
                    } else {
                      this.filters.dateFrom = dateFromString;
                    }

                    this.reactOnFilterChange = true;
                }

                let filters = this.filters

                if (filters.phone) {
                    filters.phone = filters.phone.replace(/\D*(\d{3})\D*(\d{3})\D*(\d{3})\D*/, '$1 $2 $3');
                }

                const params = {
                    offset: page > 1 ? itemsPerPage*(page-1) : 0,
                    ...this.filters
                };

                if (-1 !== itemsPerPage) {
                    params.limit = itemsPerPage;
                }

                if (!params.status) {
                    delete params.status;
                }

                const response = await api.get('/api/price-lists', {params});
                this.loading = false;

                this.items = response.data;
                this.reactOnFilterChange = false;

                setDatatableOptions.call(this);

                setTimeout(() => {
                    this.reactOnFilterChange = true;
                }, 1000); // Delay the change a bit to avoid performing another query.
            },
            getStatusText(status) {
                return getStatusText(status);
            },
        },
        created() {
          this.get();
          this.getCompanies();
          getDatatableParams.call(this);
        }
    }
</script>

<style lang="css" scoped>
    .row-pointer >>> td {
      height: auto !important;
      padding: 0.5rem !important;
    }
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .v-chip {
        white-space: break-spaces !important;
        line-height: 14px;
        width: 100%;
        padding: 9px;
    }

    .v-chip .v-chip__content {
        max-width: 100%;
        height: auto;
        overflow: auto;
        min-height: 32px;
        white-space: pre-wrap;
    }
</style>